import React, { useContext } from 'react';
import { Chart } from 'iconsax-react';
import { ThemeContext } from '../theme';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

export default function PollCard({ title, votes, options = [] }) {
  const theme = useContext(ThemeContext);

  return (
    <div
      style={{
        backgroundColor: theme.cardBg,
        borderRadius: s(20),
        padding: `${s(24)}px ${s(12)}px`,
        display: 'flex',
        flexDirection: 'column',
        gap: s(12),
        width: s(460),
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      {/* Header row: chart icon + label  |  vote count */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: s(12) }}>
          {/* Dark stacked icon */}
          <div style={{ position: 'relative', width: s(35), height: s(35), flexShrink: 0 }}>
            <div style={{ position: 'absolute', inset: 0, backgroundColor: theme.btnPrimaryBg, borderRadius: s(5) }} />
            <div style={{ position: 'absolute', top: s(6), left: s(6), width: s(24), height: s(24), display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Chart size={s(20)} variant="Linear" color={theme.btnPrimaryText} />
            </div>
          </div>
          <span className="font-satoshi" style={{ fontSize: s(16), fontWeight: 500, color: theme.text100, lineHeight: `${s(24)}px` }}>
            This week's poll
          </span>
        </div>
        <span className="font-satoshi" style={{ fontSize: s(14), fontWeight: 500, color: '#5d7b88', lineHeight: `${s(20)}px` }}>
          {votes}
        </span>
      </div>

      {/* Question */}
      <p
        className="font-satoshi font-bold"
        style={{ margin: 0, fontSize: s(18), lineHeight: `${s(24)}px`, color: theme.text100 }}
      >
        {title}
      </p>

      {/* Poll bars */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: s(6) }}>
        {options.map((opt, i) => (
          <div
            key={i}
            style={{
              position: 'relative',
              height: s(42),
              borderRadius: s(10),
              backgroundColor: opt.active ? '#b3c4cb' : theme.cardBg100,
              overflow: 'hidden',
            }}
          >
            {/* Fill bar */}
            <div
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                height: '100%',
                width: `${opt.percent}%`,
                backgroundColor: opt.active ? '#5d7b88' : theme.inputBorder,
                borderRadius: s(10),
              }}
            />
            {/* Label */}
            <span
              className="font-satoshi"
              style={{
                position: 'absolute',
                left: s(22),
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: s(16),
                fontWeight: 500,
                color: opt.active ? '#FFFFFF' : theme.text400,
                whiteSpace: 'nowrap',
                zIndex: 1,
              }}
            >
              {opt.label}
            </span>
            {/* Percentage */}
            <span
              className="font-satoshi"
              style={{
                position: 'absolute',
                right: s(10),
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: s(14),
                fontWeight: 500,
                color: opt.active ? '#495f6a' : theme.text400,
                zIndex: 1,
              }}
            >
              {opt.percent}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
